import { render } from "./GenerateReport.vue?vue&type=template&id=827bd3ec&scoped=true"
import script from "./GenerateReport.vue?vue&type=script&lang=js"
export * from "./GenerateReport.vue?vue&type=script&lang=js"

import "./GenerateReport.vue?vue&type=style&index=0&id=827bd3ec&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827bd3ec"]])

export default __exports__